import { QuestionCircleOutlined } from '@ant-design/icons';
import styled from 'styled-components';

export const StyledQuestionCircleOutlined = styled(QuestionCircleOutlined)`
  cursor: pointer;
  margin-right: 0.5rem;
`;
